import { Component, inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { IdentityStore, IdentityStoreType } from '@appState';
import { NgSelectConfig } from '@ng-select/ng-select';

@Component({
  selector: 'ocf-root',
  template: '<router-outlet></router-outlet>',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class MainComponent implements OnInit {
  private identityStore: IdentityStoreType = inject(IdentityStore);
  private ngSelectConfig: NgSelectConfig = inject(NgSelectConfig);
  constructor() {
    this.ngSelectConfig.appendTo = 'body';
    this.ngSelectConfig.appearance = 'outline';
  }

  ngOnInit(): void {
    this.identityStore.checkAuth();
  }
}
